import PropTypes from "prop-types";

const SelectedOption = (props) => {
    const {data} = props

    return <div className={'my-1'} key={data.id}>
        {props.showId && <span>[{data.id}] </span>}{data.nazwa}
    </div>

}

export default SelectedOption

SelectedOption.propTypes = {
    data: PropTypes.object.isRequired,
    showId: PropTypes.bool
};